/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import './store';
import '../../pages/home/homeMarketStore';
import { namespace } from 'vuex-class';
import { Component, Mixins, ProvideReactive } from 'vue-property-decorator';
import type { CreditDataType } from '@/api/homeV2Status/types';

import isPrerendering from '@/shared/utils/isPrerendering';
import { RouterV2Enum, RouterV3Enum } from '@/router/router-names';
import { UserAuthMixins } from '@/mixins/user-auth';
import platform from '@/shared/utils/platform';
import { session } from '@/shared/utils/storage';
import store from '@/store';
import { getHomePath, HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';
import { HomeThemeEnums } from '@/shared/utils/pageTheme';
import LoadingPage from '@/components/loading-page';
import {
  changeTabbarShowStatus, getSkTabInfo, removeContainerLoading, skNativeContainer,
} from '@/api/native/container';
import { listerBack } from '@/shared/utils/backListener';
import Bootstrap from '@/shared/utils/bootstrap';
import {
  TempAmountSceneEnum,
  StateType as EventLoopStateType,
  StoreActionType as EventLoopStoreActionType,
} from '@/store/tempAmount/types';
import { isHelloWechatMini } from '@/api/native/wechat';
import {
  initActivityModulesConfig, ActivityPageTypeEnums,
} from '@/shared/activity-undertake';
import RouterHelper from '@/shared/utils/routerHelper';
import { EventLoopNotifySceneEnum } from '@/api/tempAmount/types';
import { StateType as BaseStoreStateType } from '@/store/base/types';
import { NormalPreCreditModelEnums } from '@/enums/home-type';
import { PageThemeTypeEnum } from '@/enums/pageThemeType';
import { HomeV3PageThemeList } from '@/pages/home/constant';
import { dispatchActions } from '@/store/dispatchActions';
import { PageSceneEnum, PageSourceEnum } from '@/api/common/types';
import { DisplayVersionEnum, StateType } from './types';
import Autarkey from './autarky';

const BaseStore = namespace('base');
const HomeStore = namespace('home');
const HomeMarketStore = namespace('homeMarketStore');
const TempAmountStore = namespace('tempAmount');
const style: Dictionary = require('./index.module.scss');

const _isPrerendering = isPrerendering();

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

@Component
export default class Home extends Mixins(UserAuthMixins, Autarkey) {
  @HomeStore.State creditData!: CreditDataType | null;

  @HomeStore.State loopQueryPreCreditIssued!: StateType['loopQueryPreCreditIssued'];

  @BaseStore.State pageThemeType!: BaseStoreStateType['pageThemeType'];

  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  @HomeStore.Action getUserAutarkyState!: () => Promise<boolean>;

  @HomeStore.Action getAliProductStatus!: () => Promise<void>;

  @HomeStore.Action getCanSlideInQualityAb!: () => Promise<void>;


  @HomeStore.Action getFianceCardAdvConfig!: () => Promise<void>;

  @HomeStore.Action $updateState!: (data: Dictionary) => Promise<void>;

  @HomeMarketStore.Action queryHomeInstallMallSummary!: () => Promise<void>;

  @TempAmountStore.Action checkNotExistTempAmount!: EventLoopStoreActionType['checkNotExistTempAmount'];

  @TempAmountStore.Action requestApplyTempAmount!: EventLoopStoreActionType['requestApplyTempAmount'];

  @TempAmountStore.Action commonPollingNotifyIssued!: EventLoopStoreActionType['commonPollingNotifyIssued'];

  @TempAmountStore.State tempAmountStatus!: EventLoopStateType['tempAmountStatus'];

  @ProvideReactive() homePage: Home | null = null;

  private timerId: NodeJS.Timer | null = null;

  // 当前路由需要在初始化的时候显示Loading
  private needShowLoading = true;

  // 目标版本首页渲染完成之后，消息通知：需要隐藏Loading
  private shouldHideLoading = false;

  // 为避免Loading页面一闪而逝，人为添加一些显示时长控制，超过一定时间才能隐藏Loading
  private canHideLoading = false;

  // 是否显示Loading页面
  private get showLoadingPage(): boolean {
    return this.needShowLoading && !(
      this.shouldHideLoading && this.canHideLoading
    );
  }

  // TODO
  private get currentPage() {
    return session.get('currentPage') || null;
  }

  /** 是否app里的taglesshome */
  private get isTaglessHome() {
    return [RouterV2Enum.taglessHome].includes(
      this.$route.path as RouterV2Enum,
    );
  }

  // 判断当前是否是入口路由，如果不是入口路由，则不自动做路由跳转处理
  private get isCurrentHomeRoute(): boolean {
    const routePath = this.$route.path;

    return RouterV2Enum.home === routePath || RouterV2Enum.aliminiHome === routePath;
  }

  private get isAliApplyFailed(): boolean {
    return !!(this.creditData
      && this.creditData.displayVersion)
      && this.creditData.displayVersion === DisplayVersionEnum.ALIAPPLYFAILED;
  }

  private get isPocketMoneyScene(): boolean | undefined {
    const {
      preCredit,
      normalPreCreditModel,
    } = this.creditData || {};
    return preCredit && normalPreCreditModel === NormalPreCreditModelEnums.POCKET_MONEY_LOAN;
  }

  // 计算目标首页path路径
  private get targetRoute(): string {
    const {
      creditStatus,
      hasOrder,
      preCredit,
    } = this.creditData || {};

    if (platform.isAlipayMini || platform.isDingTalk) {
      if (this.isAliApplyFailed) {
        return RouterV2Enum.aliApplyFaildHome;
      }
      // 支付宝或者钉钉，授信额度失效且有待还款订单，跳到品质首页
      if (creditStatus || (!creditStatus && hasOrder)) {
        return RouterV2Enum.qualityAliminiHome;
      }
      return RouterV2Enum.taglessAliminiHome;
    }

    /**
     * 1. 命中新版首页ab，且非自营升级用户，则跳转到新版首页
     * 2. 零用钱场景，跳转到零用钱首页
     */
    if ((HomeV3PageThemeList.includes(this.pageThemeType as PageThemeTypeEnum)
      && !this.isUpgradeProcessingAndCredited)
      || this.isPocketMoneyScene) {
      return RouterV3Enum.home;
    }

    if (creditStatus || this.currentPage) {
      /** 预授信用户，跳到tagless首页 */
      if (preCredit) {
        return RouterV2Enum.taglessHome;
      }
      // this.currentPage app 无标签用户页面滑动切换到品质版本内容页面
      return RouterV2Enum.qualityHomePage;
    }

    return RouterV2Enum.taglessHome;
  }

  public hideLoading(): void {
    this.shouldHideLoading = true;
  }

  public shouldCorrectRouteByCredit(): boolean {
    return this.$route.path !== this.targetRoute;
  }

  // 授信成功之后在授信结果页面会重新更新授信状态
  // 此时需要保证用户backHome之后能够通过此方法对对应的子首页进行跳转；
  public correctRouteByCredit(): void {
    if (this.shouldCorrectRouteByCredit()) {
      this.canHideLoading = true;
      this.shouldHideLoading = true;

      this.goTargetRoute(this.targetRoute, true);
    }
  }

  public getIsUpgradeProcessingAndCredited(): boolean {
    return this.isUpgradeProcessingAndCredited;
  }

  private created() {
    const htmlElem = document.querySelector('html') as HTMLElement;

    this.homePage = this;

    this.needShowLoading = htmlElem.getAttribute('show-loading') === 'true';

    if (_isPrerendering) {
      if (this.isCurrentHomeRoute) {
        // 预渲染阶段，html-render-preparation 脚本还未注入，所以此时html上没有show-loading标记
        this.needShowLoading = true;

        // 预渲染环节，只针对初始化页面做Loading，其他页面不显示Loading
        this.shouldHideLoading = false;
        this.canHideLoading = false;
      }

      return;
    }

    if (!this.checkIsLogoutUser()) {
      this.getAuthAliminiInit();
    }
  }

  private async initHomeThemeType() {
    let homeThemeType = null;

    if (this.targetRoute === RouterV2Enum.qualityHomePage) {
      /**
       * 品质首页，页面主题设置：
       * 若是老客升级，则为 HomeThemeEnums.AUTARKY_NEW
       */
      if (this.isUpgradeProcessing) {
        homeThemeType = HomeThemeEnums.AUTARKY_NEW;
      }
    }

    await this.$updateState({
      homeThemeType,
    });
  }

  private async mounted() {
    if (_isPrerendering && this.isCurrentHomeRoute) {
      document.dispatchEvent(new Event('render-event'));
    } else {
      /** 不能自动取消 需要持续监听 */
      if (await skNativeContainer()) {
        this.refreshHomePageData('nativeContainer');
      }
      /** 是否从哈啰app，钱包页 tab 打开首页，打开二级页面, 如果是，需要持续监听 首页展示，刷新页面数据 */
      if (store.state.base.isHybridAppMode) {
        this.refreshHomePageData('walletTab');
      }
    }
  }

  // 定义 刷新页面数据 方法
  private async refreshHomePageData(mode: string) {
    /** 监听app容器切换, 刷新首页数据 */
    listerBack(async () => {
      if (HOME_ALL_VERSION_ROUTE_PATHS.includes(this.$route.path as RouterV2Enum)) {
        /** ios 回到首页，需要判断是否是wallet 借钱tab显示的时候 才去刷新页面数据 ,
         *  isFinanceTabShow === undefined 或者true时，去刷新页面数据 */
        if (platform.isIOS && mode === 'walletTab' && window.isFinanceTabShow === false) {
          return;
        }
        const { haveShown } = await getSkTabInfo('home');
        if (mode === 'nativeContainer' && haveShown) {
          /** 回到首页 展示 tabbar */
          changeTabbarShowStatus(true);
        }

        /** debugg工具设置token场景，不去置换新的token */
        if (!store.state.base.fakeToken) {
        /** 登录信息重新获取 */
          await Bootstrap.init();
        }

        /** 是否注销判断 */
        if (!this.checkIsLogoutUser()) {
          this.getAuthAliminiInit();
        }
      }
    }, false);
  }

  // 获取用户的授信相关数据并跳转对应首页
  private getAuthAliminiInit() {
    this.jumpToTargetRoute();
    if (store.state.base.token) {
      Promise.all([
        this.getCreditData(),
        (platform.isAlipayMini || platform.isDingTalk) ? this.getAliProductStatus() : null,
        this.getUserAutarkyState(), // 获取用户自营状态
        this.getFianceCardAdvConfig(), // 请求无标签banner广告位数据
        /** 获取信贷业务通用信息 */
        dispatchActions.base.getBusinessInfoExtra({ pageSource: PageSourceEnum.HOME }),
        dispatchActions.base.getIsWebviewSkNativeContainer(), // 获取是否在数科容器化Webview容器
        store.dispatch('homeStore/getShowRateFloorExpResult'), // 获取是否蓝版首页仅展示利率下限实验结果
        store.dispatch('homeStore/getShowBrandingExpResult'), // 获取首页品牌化文案展示实验结果
        store.dispatch('homeStore/getHaiXiaoQueryStatusResult', { scene: PageSceneEnum.HOME }), // 获取海消联合品牌展示状态
        initActivityModulesConfig(ActivityPageTypeEnums.HOME), // 初始化首页模块配置
      ]).then(async () => {
        if (store.state.base.businessInfoExtra?.userInfo?.ocrAfterLoan) {
          /** 若是ocr后置用户，则通知服务端拉取二要素、异步拉取ocr照片 */
          await dispatchActions.base.getSyncUserInfo();
        }
        // 前置请求，防止页面抖动，但是不同步请求，防止页面依赖三方接口渲染
        // this.queryHomeInstallMallSummary(); // 商城接口先不调用
        await this.initHomeThemeType();

        /** 最终的首页路由Path */
        const curRoute = this.targetRoute;

        if (this.$route.path !== curRoute) {
          await this.goTargetRoute(curRoute);
        } else {
          removeContainerLoading();
        }

        /** 新版v3首页内部自行轮询临额、预授信下发 */
        if (curRoute !== RouterV3Enum.home) {
          this.mutliSceneCommonLoopQuery(curRoute);
        }
      }).catch(() => {
        // 异常情况，默认跳转老版本页面
        if (this.isCurrentHomeRoute) {
          this.goTargetRoute(RouterV2Enum.taglessHome);
        }
      }).finally(async () => {
        /**
         * 数据更新后，移除客户端Tabbar容器原生Loading
         * 新版v3首页场景，为避免页面抖动，等跳转v3首页mounted后，再移除Loading
         */
        if (this.targetRoute !== RouterV3Enum.home) {
          removeContainerLoading();
        }

        /** todo 去除ab */
        await this.getCanSlideInQualityAb();
      });
    } else {
      // 未登录时, 不能删，不跳转会一直在 loading 页面
      this.goTargetRoute(platform.isAlipayMini || platform.isDingTalk
        ? RouterV2Enum.taglessAliminiHome
        : RouterV2Enum.taglessHome);
    }
  }

  /** 多场景通用轮询：临额、预授信下发 */
  private async mutliSceneCommonLoopQuery(curRoute: string) {
    const loopSceneList: EventLoopNotifySceneEnum[] = [];

    if (curRoute === RouterV2Enum.qualityHomePage) {
      /**
       * 仅在品质首页，若检查当前无有效的临额，则尝试申请 “授信额度不足步长”的场景
       */
      const notExistTempAmount = await this.checkNotExistTempAmount();

      if (notExistTempAmount) {
        this.requestApplyTempAmount({ scene: TempAmountSceneEnum.AMOUNT_NOT_ENOUGH });
      } else if (this.tempAmountStatus?.tempAmountApplying) {
        loopSceneList.push(EventLoopNotifySceneEnum.TEMP_AMOUNT);
      }
    }

    if (RouterHelper.isLastPageRoute(RouterV2Enum.preApplyChoose)) {
      loopSceneList.push(EventLoopNotifySceneEnum.PRE_CREDIT);
    }

    if (loopSceneList.length) {
      await this.commonPollingNotifyIssued({
        loopSceneList,
      });

      if (this.loopQueryPreCreditIssued) {
        await this.$updateState({
          /** 重置标识，避免tab切换重复触发 */
          loopQueryPreCreditIssued: false,
        });
        /** 预授信仅展示在无标签，若是分发前用户是品质首页(老客)，则需要刷新路由 */
        if (this.shouldCorrectRouteByCredit()) {
          this.correctRouteByCredit();
        }
      }
    }
  }

  // 根据平台类型以及用户授信, 执行页面路由跳转逻辑
  private jumpToTargetRoute() {
    // 只有在访问初始化页面的时候才显示loading效果
    if (this.isCurrentHomeRoute) {
      if (this.targetRoute && !this.needShowLoading) {
        this.canHideLoading = true;
        this.shouldHideLoading = true;
      } else {
        this.$ubtPageButton(
          'finance_loadingHomePage',
          'homePageVersion',
          'qualityHomePageVersion',
        );

        this.canHideLoading = true;
      }
    } else {
      this.canHideLoading = true;
      this.shouldHideLoading = true;
    }
  }

  private goTargetRoute(
    routePath: string,
    // 是否强制替换，在子首页校验的时候如果发现授信状态和当前子首页不匹配需要做replace路由操作
    replace?: boolean,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.$route.path.includes(getHomePath())) {
        // 支付宝小程序、 钉钉浏览器 直接使用replace跳转，避免回退2次才能关闭webview的问题
        if (platform.isAlipayMini || platform.isDingTalk || replace) {
          this.$router.replace(
            {
              path: routePath,
              query: { ...this.$route.query },
            },
            resolve,
            reject,
          );
        } else {
          // 其它环境由于会存在广告弹窗业务逻辑，所以需要使用push操作，使得回退时能够正常显示弹窗
          this.$router.push(
            {
              path: routePath,
              query: { ...this.$route.query },
            },
            resolve,
            reject,
          );
        }
      } else {
        resolve();
      }
    });
  }

  private render() {
    return (
      <div class={[
        style.homeContainer,
        this.isTaglessHome && style.taglessContainer,
        store.state.base.isHybridAppMode ? 'hybridAppMode' : '',
        isHelloWechatMini() ? 'helloWechatMiniAdapt' : '',
        (platform.isAndroid || platform.isHarmony) ? 'homeAndroidAdapt' : '',
      ]}>
        <router-view />

        {this.showLoadingPage && (
          <LoadingPage pageId="finance_home_loadingPage" />
        )}
      </div>
    );
  }

  private beforeDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  }
}
